import { render, staticRenderFns } from "./DeleteTodoItem.vue?vue&type=template&id=e5f52474"
import script from "./DeleteTodoItem.vue?vue&type=script&lang=js"
export * from "./DeleteTodoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports